export const GET_SUBSCRIBER_DOCUMENTS_QUERY_KEY = 'subscriber_documents';

export const GET_SUBSCRIBER_SINGLE_DOCUMENT_QUERY_KEY = (
  documentRequestId: number
) => ['subscriber_documents', documentRequestId] as const;
